import { SActionButton } from 'components/directive/directiveSteppedGuide/styled'
import { useCreateDirectiveLogic } from 'components/directive/utils/directiveUtils'
import { DirectiveType } from 'components/directive/utils/types'
import { Icon } from 'components/icon'

interface Props {
  className?: string
  type: DirectiveType
}

export function DirectiveCreateButton(props: Props) {
  const { cta, create, isCreating } = useCreateDirectiveLogic(props.type)

  return (
    <SActionButton
      variant="secondary"
      size={['medium', 'large']}
      tone="dark"
      type="button"
      className={props.className}
      onClick={create}
      loading={isCreating}
      leftIcon={<Icon name="ArrowRight" />}
    >
      {cta}
    </SActionButton>
  )
}
